var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",class:_vm.classObject,attrs:{"id":"app"}},[_c('Main',{on:{"click":function($event){_vm.MobMenuIsOpen = !_vm.MobMenuIsOpen}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }